export default __webpack_public_path__ + "static/media/serene-heights-master-plan.9c16e2d6.webp";